import { Setting } from 'types/back-office-settings';
import { DefaultCurrencyControl } from '../DefaultCurrencyControl';
import type { SettingSectionLayout } from '../settingLayout';

/** The "Invoice dates, numbering and currency" section: its group bands and their rows, in page order. */
export const INVOICE_DATES_SECTION: SettingSectionLayout = {
    anchor: 'invoice-dates',
    groups: [
        {
            id: 'invoice-dates-currency',
            rows: [{ key: Setting.DEFAULT_CURRENCY, sub: [{ kind: 'value', Content: DefaultCurrencyControl }] }],
        },
    ],
};
